import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Iresponse_solicitud, SolicitudNhModel } from '../../../domain/model/no-hospitalario/solicitud/entity/solicitud-nh.model';
import { SolicitudNhGateway } from '../../../domain/model/no-hospitalario/solicitud/gateway/solicitud-nh-gateway';
import { CancelacionVisitaNhRequest } from './../../../domain/model/no-hospitalario/solicitud/dto/cancelacion-visita-nh-request';
import { PacienteCoberturaNh } from './../../../domain/model/no-hospitalario/solicitud/dto/paciente-cobertura-nh-dto';
import { PacientesMockData } from './../../../shared/mocks/pacientes-mock.data';
import { FiltrosSolicitudNhRequest } from './dto/request/filtros-solictud-nh-request';
import { GuardarSolicitudNhRequest } from "./dto/request/guardar-solicitud-nh-request";
import { PageResponse } from './dto/response/page-response';


@Injectable({
  providedIn: 'root'
})
export class SolicitudNhService extends SolicitudNhGateway {


  private url: string;
  private port: string;

  constructor(private http: HttpClient) {
    super();
    this.url = `${environment.apiBaseUrl}`;
    this.port = `${environment.portBaseUrl}`;
  }


  consultarSolicitudes(requestBody: FiltrosSolicitudNhRequest): Observable<PageResponse<SolicitudNhModel>> {
    const url = `${this.url}${this.port}/api_ingreso/solicitud/consultarSolicitudes`;
    return this.http.post<PageResponse<SolicitudNhModel>>(url, requestBody);
  }

  guardarSolicitud(requestBody: GuardarSolicitudNhRequest): Observable<Iresponse_solicitud> {
    const url = `${this.url}${this.port}/api_ingreso/solicitud/guardar`;
    return this.http.post<Iresponse_solicitud>(url, requestBody);
  }

  consultarDatosPaciente(tipoDocumento: string, documento: string): Observable<PacienteCoberturaNh> {

        if (documento === '1' || documento === '2' || documento === '3' || documento === '4' || documento === '5') {
          
          const pacienteSimulado = PacientesMockData.buscarPacientePorDocumentoNH(documento);
          
          if (pacienteSimulado) {
            return of(pacienteSimulado).pipe(
              delay(500) 
            );
          } else {
            return throwError(() => new Error(`Paciente simulado no encontrado para documento: ${documento}`));
          }
        }
        
    const url = `${this.url}${this.port}/api_ingreso/paciente/${tipoDocumento}/${documento}`;
    return this.http.get<PacienteCoberturaNh>(url);

  }

  consultarUltimasSolcitudesPorPaciente(tipoIdentificacion: string, numeroIdentificacion: string): Observable<PageResponse<SolicitudNhModel>> {
    const url = `${this.url}${this.port}/api_ingreso/solicitud/consultarUltimasSolicitudes/${tipoIdentificacion}/${numeroIdentificacion}`;
    return this.http.get<PageResponse<SolicitudNhModel>>(url);
  }

  cancelarvisita(requestBody: CancelacionVisitaNhRequest): Observable<any> {
    const url = `${this.url}${this.port}/api_ingreso/solicitud/cancelarVisita`;
    return this.http.post<any>(url, requestBody);
  }
}
